import type { FormatterFactory } from '../types';

export const user: FormatterFactory = () => ({
  toText: (value) => {
    if (value == null) {
      return '';
    }
    const users = (globalThis as any).$app?.users;
    return users ? users.getUserDisplayName(value) : String(value);
  },
});
